import { all } from 'redux-saga/effects';
import LoFSagas from './LoF.sagas';
import CoFSagas from './CoF.sagas';
import RiskSagas from './Risk.sagas';
import assetFieldsSaga from './asset.sagas';
import componentSaga from './component.saga';
import pipeDeteriorationSagas from './pipeDeterioration.sagas';
import riskTemplateCatalogSagas from './RiskTemplateCatalog.sagas';

export default function* rootSaga() {
	yield all([
		...LoFSagas,
		...CoFSagas,
		...RiskSagas,
		...assetFieldsSaga,
		...componentSaga,
		...pipeDeteriorationSagas,
		...riskTemplateCatalogSagas,
	]);
}
